import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useRouter } from "next/router";

import CartApi from "@/api/CartApi";
import { useToastHandlers } from "@/components/toaster";
import { ymReachGoalHelper } from "@/components/YandexMetrica";

export const useAddToCartHandler = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { addToast } = useToastHandlers();
  const router = useRouter();

  const addSizeToCartMutation = useMutation(
    ({ productId }: { productId: string }) => CartApi.add(productId),
    {
      onSuccess: async (data, variables) => {
        const cartItems = data.data?.products;
        const cartCount = data.data?.count || "";
        cartCount === 1 && ymReachGoalHelper("first-cart-add");

        if (!cartItems?.length) return;

        const addedProduct = cartItems.find(
          (item) => item.size.id === variables.productId
        );

        if (addedProduct) {
          await addToast({
            photo: addedProduct.thumbnail || "",
            title: `${addedProduct.name || ""} (${addedProduct.size.name})`,
            text: "Товар добавлен в корзину",
            cartCount: cartItems.length,
            variant: "product",
            clickHandler: () => router.push("/cart-favorites"),
          });
        }
        queryClient.setQueryData(["cart", true], data);
        queryClient.setQueryData(["cart", false], data);
        queryClient.invalidateQueries(["cartCount"]);
        onSuccess && onSuccess();
      },
      onError: (error: AxiosError<{ message: string }>) => {
        const status = error.response?.status;

        switch (status) {
          case 403:
            return addToast({
              title: "Товар не удалось добавить в корзину",
              text: error.response?.data.message || "",
              variant: "base",
            });

          case 404:
            return addToast({
              title: "Товар не удалось добавить в корзину",
              text: error.response?.data.message || "",
              variant: "base",
            });

          default:
            return addToast({
              title: "Товар не удалось добавить в корзину",
              text: "ошибка на сервере",
              variant: "base",
            });
        }
      },
    }
  );

  const addToCartHandler = (productId: string) => {
    addSizeToCartMutation.mutate({ productId });
  };

  return { addToCartHandler };
};
